// 템플릿 시뮬레이션(dry-run) 화면 순수 헬퍼 — POST /mail/template/dry-run 요청 조립과 보완요청 제외.
// node:test + webpack 양쪽 사용을 위해 CommonJS 로 작성.

// 보완요청 메일은 보완검토 화면에서 확인한다 (백엔드도 400 으로 거부).
const SUPPLEMENT_SCENARIO = 'supplement-req';

// 템플릿 조건 키. 입력한 조건을 그대로 매칭에 쓴다.
const CONTEXT_FIELDS = ['campaign', 'project', 'company', 'user', 'sub_domain'];

function clean(raw) {
    return raw == null ? '' : String(raw).trim();
}

// { scenario_code, contexts: {빈 값 제외}, locale? }. ID 는 문자열 그대로 보낸다.
function buildDryRunPayload(form) {
    const f = form || {};
    const contexts = {};
    CONTEXT_FIELDS.forEach((key) => {
        const value = clean(f[key]);
        if (value) contexts[key] = value;
    });
    const payload = { scenario_code: clean(f.scenario_code), contexts };
    const locale = clean(f.locale);
    if (locale) payload.locale = locale;
    return payload;
}

function isSelectableScenario(code) {
    return Boolean(code) && code !== SUPPLEMENT_SCENARIO;
}

module.exports = {
    buildDryRunPayload,
    isSelectableScenario,
};
